import { combineReducers } from 'redux';

import { reducer as listzones } from './listzonesModule';

export default combineReducers({
	listzones,
});
